<template>
  <v-card flat class="section-card">
    <v-card-text class="section">
      <p class="section-title" style="margin-bottom: 20px;">Sell order</p>
      <v-layout row wrap>
        <v-flex md1 xs12 class="description">Order ID</v-flex>
        <v-flex md11 xs12 class="value">{{sellOrder.uuid}}</v-flex>
        <v-flex md1 xs12 class="description">Price</v-flex>
        <v-flex md11 xs12 class="value">{{sellOrder.base_currency}} {{sellOrder.price}}</v-flex>
      </v-layout>
    </v-card-text>
    <v-card-text class="section mt-2">
      <p class="section-title">Buy orders ({{buyOrders.length}})</p>
      <v-data-table
        :headers="buyOrderHeaders"
        :items="buyOrders || []"
        :disable-initial-sort="true"
        :item-key="uuid"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <tr v-if="!isMobile">
            <td>{{props.item.ts_opened_utc | formatDate("DD MMM YYYY HH:mm")}}</td>
            <td>{{props.item.ts_closed_utc | formatDate("DD MMM YYYY HH:mm")}}</td>
            <td>{{props.item.price.toFixed(8)}} {{props.item.market_name.slice(props.item.market_name.indexOf(':')+1).split('-')[0]}}</td>
            <td>{{props.item.quantity.toFixed(8)}}</td>
            <td>{{props.item.commission_paid.toFixed(8)}} {{props.item.market_name.slice(props.item.market_name.indexOf(':')+1).split('-')[0]}}</td>
            <td>{{props.item.uuid}}</td>
          </tr>
          <tr v-else>
            <td class="pb-3 pt-2">
              <v-layout row wrap>
                <v-flex md12 xs12>
                  <v-layout row wrap>
                    <v-flex xs6 lg6 md6>
                      Opened (EET)
                    </v-flex>
                    <v-flex xs6 lg6 md6>
                      {{props.item.ts_opened_utc | formatDate("DD MMM YYYY HH:mm")}}
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 lg6 md6>
                      Closed (EET)
                    </v-flex>
                    <v-flex xs6 lg6 md6>
                      {{props.item.ts_closed_utc | formatDate("DD MMM YYYY HH:mm")}}
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 lg6 md6>
                      Price
                    </v-flex>
                    <v-flex xs6 lg6 md6>
                      {{props.item.price.toFixed(8)}} {{props.item.market_name.slice(props.item.market_name.indexOf(':')+1).split('-')[0]}}
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 lg6 md6>
                      Quantity
                    </v-flex>
                    <v-flex xs6 lg6 md6>
                      {{props.item.quantity.toFixed(8)}}
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 lg6 md6>
                      Commission
                    </v-flex>
                    <v-flex xs6 lg6 md6>
                      {{props.item.commission_paid.toFixed(8)}} {{props.item.market_name.slice(props.item.market_name.indexOf(':')+1).split('-')[0]}}
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 lg6 md6>
                      Order ID
                    </v-flex>
                    <v-flex xs6 lg6 md6>
                      {{props.item.uuid}}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<style scoped>

>>> th {
  font-size: 12px !important;
  line-height: 14px !important;
}
>>> td {
  font-size: 14px !important;
  line-height: 17px !important;
}

.theme--light .section {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px !important;
  padding: 32px;
}
.theme--light .description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7395d0;
}
.theme--light .value {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
}
.theme--light .section-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #103a84;
}
/******************************************************/
.theme--dark .section {
  border: 1px solid #303030;
  box-sizing: border-box;
  border-radius: 10px !important;
  padding: 32px;
}
.theme--dark .description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(235, 235, 245, 0.6);
}
.theme--dark .value {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #e9e9e9;
}
.theme--dark .section-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #e9e9e9;
}
.theme--dark .section-card {
  background-color: #212121;
}
</style>

<script>
import axios from "axios"
import TradeDetails from "~/components/openorders/TradeDetails"
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import {mapGetters} from "vuex";

const timezone = moment()
  .tz(moment.tz.guess())
  .format("z");

export default {
  components: {
    TradeDetails
  },
  props: {
    baseCurrency: "",
    sellOrder: {},
    uuid: null
  },
  data: function() {
    return {
      buyOrders: [],
      windowWidth: window.innerWidth
    };
  },
  computed: {
    buyOrderHeaders: function() {
      if (this.isMobile) {
        return [{ text: `Opened (${timezone})`, value: "ts_opened_utc" }];
      } else {
        return [
          { text: `Opened (${timezone})`, value: "ts_opened_utc" },
          { text: `Closed (${timezone})`, value: "ts_closed_utc" },
          { text: "Price", value: "price" },
          { text: "Quantity", value: "quantity" },
          { text: "Commission", value: "commission" },
          { text: "Order ID", value: "uuid" }
        ];
      }
    },
    isMobile() {
      return this.windowWidth < 600;
    }
  },
  created: async function() {
    axios.get("/api/v1/openorders/details/" + this.sellOrder.uuid).then(res => {
      this.buyOrders = res.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/openorders/TradeDetails.vue